export const data = [
  {
    date: 'Mar 22',
    Credits: 110,
  },
  {
    date: 'Mar 23',
    Credits: 60,
  },
  {
    date: 'Mar 24',
    Credits: -80,
  },
  {
    date: 'Mar 25',
    Credits: 40,
  },
  {
    date: 'Mar 26',
    Credits: -40,
  },
  {
    date: 'Mar 27',
    Credits: 80,
  },
];

export const data2 = [
  { month: 'January', Exports: 1200, Blender: 900, Animation: 200 },
  { month: 'February', Exports: 1900, Blender: 1200, Animation: 400 },
  { month: 'March', Exports: 400, Blender: 1000, Animation: 200 },
  { month: 'April', Exports: 1000, Blender: 200, Animation: 800 },
  { month: 'May', Exports: 800, Blender: 1400, Animation: 1200 },
  { month: 'June', Exports: 750, Blender: 600, Animation: 1000 },
];

export const data3 = [
  { name: 'USA', value: 400, color: 'indigo.6' },
  { name: 'India', value: 300, color: 'yellow.6' },
  { name: 'Japan', value: 300, color: 'teal.6' },
  { name: 'Other', value: 200, color: 'gray.6' },
];

export const data4 = [
  {
    product: 'GLB Exports',
    count: 120,
  },
  {
    product: 'STL Exports',
    count: 98,
  },
  {
    product: 'OBJ Exports',
    count: 86,
  },
  {
    product: 'MP4 Exports',
    count: 99,
  },
  {
    product: 'Sloyd Exports',
    count: 85,
  },
  {
    product: 'Blender Blender',
    count: 65,
  },
];

export const graphs = [
  {
    id: 'graph-1',
    chartType: 'AreaChart',
    data,
    dataKey: 'date',
    series: [{ name: 'Credits', color: 'violet.6' }],
    extraProps: {
      widthLegend: false,
      type: 'split',
      strokeWidth: 1,
      dotProps: { r: 2, strokeWidth: 1 },
      activeDotProps: { r: 3, strokeWidth: 1 },
      h: 200,
    },
  },
  {
    id: 'graph-2',
    chartType: 'BarChart',
    data: data2,
    dataKey: 'month',
    series: [
      { name: 'Exports', color: 'violet.6' },
      { name: 'Blender', color: 'blue.6' },
      { name: 'Animation', color: 'teal.6' },
    ],
    extraProps: {
      h: 200,
    },
  },

  {
    id: 'graph-4',
    chartType: 'RadarChart',
    data: data4,
    dataKey: 'product',
    series: [{ name: 'count', color: 'violet.6', opacity: 0.2 }],
    extraProps: {
      h: 300,
      withPolarRadiusAxis: true,
    },
  },
];
